export enum InteractionType {
    DoorLocked = 'door_locked',
    DoorOpen = 'door_open',
    StairsDown = 'stairs_down',
    StairsUp = 'stairs_up',
    EntityInteract = 'entity_interact',
    ActorAttack = 'actor_attack',
    None = 'none'
}
